import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'categories',
    initialState: {categories: [], child_categories: []},
    reducers:{
        getAllCategories: (state,action)=>{
            state.categories = action.payload
        },
        getAllChildCategories: (state,action)=>{
            state.child_categories = action.payload
        }
    }
})

export const getCategories = () => apiCall({
    url: 'categories/',
    method: 'GET',
    onSuccess: slice.actions.getAllCategories.type
})

export const getCategoriesId = (id) => apiCall({
    url: 'categories/?child=' + id,
    method: 'GET',
    onSuccess: slice.actions.getAllChildCategories.type
})

export default slice.reducer